export default __webpack_public_path__ + "static/media/5.241e4f98.jpg";